import {useEffect, useState} from "react";
import PropTypes from "prop-types";
import Fade from "@mui/material/Fade";
import SoftBox from "components/SoftBox";
import SoftAlertRoot from "./AlertRoot";
import SoftAlertCloseIcon from "./AlertCloseIcon";

function SoftAlert({color = "info", dismissible = true, timeout = 300, mount = false, children, ...rest}) {
    const [alertStatus, setAlertStatus] = useState(mount ? "mount" : "unmount");

    useEffect(() => {
        if (mount) {
            setAlertStatus("mount");
        }
    }, [mount]);

    const handleAlertStatus = () => setAlertStatus("fadeOut");

    const alertTemplate = (show = true) => (
        <Fade in={show} timeout={timeout}>
            <SoftAlertRoot ownerState={{color}} {...rest}>
                <SoftBox display="flex" alignItems="center" color="white">
                    {children}
                </SoftBox>
                {dismissible ? (
                    <SoftAlertCloseIcon onClick={show ? handleAlertStatus : null}>
                        &times;
                    </SoftAlertCloseIcon>
                ) : null}
            </SoftAlertRoot>
        </Fade>
    );

    switch (alertStatus) {
        case "mount":
            return alertTemplate(true);
        case "fadeOut":
            setTimeout(() => setAlertStatus("unmount"), timeout);
            return alertTemplate(false);
        default:
            return null;
    }
}

SoftAlert.defaultProps = {
    color: "info",
    dismissible: false,
};

SoftAlert.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    dismissible: PropTypes.bool,
    children: PropTypes.node.isRequired,
    timeout: PropTypes.number,
    mount: PropTypes.bool,
};

export default SoftAlert;
